
import './App.css';
import {SCRoutes as Routes} from './routes';



const App = (props) => {

return (<Routes {...props}/>)





};

export default App;
